export default __webpack_public_path__ + "static/media/work_ec-contact.7e87892e.jpg";